export default __webpack_public_path__ + "static/media/standard_walk.33792ad6.gif";